import { cn } from '@utils/cn';
import { TabsProps } from './types';
import { useTranslation } from 'react-i18next';

export const Tabs = <T extends string>({ value, setValue, options, disabled }: TabsProps<T>) => {
  const { t } = useTranslation('app', { keyPrefix: 'tabs' });

  return (
    <nav className="w-fit">
      <ul className="flex">
        {options.map((el) => (
          <li key={el}>
            <button
              type="button"
              key={`tabs-option-${el}`}
              className={cn([
                'select-none border-b-2 px-6 py-1 text-m font-bold text-neutral-700 disabled:text-opacity-30',
                el === value && 'border-primary-400 text-primary-400 disabled:text-opacity-100',
                disabled && 'cursor-not-allowed',
              ])}
              disabled={el === value || disabled}
              onClick={() => setValue(el)}>
              {t(el)}
            </button>
          </li>
        ))}
      </ul>
    </nav>
  );
};
